<template>
   <div class="message-dialog-container">
        <div v-if="isLoading" class="loading-container d-flex align-items-center justify-content-center w-100">
            <div class="loading-label-wrapper text-center">
                <div v-if="!isDoneLoading" class="loading m-bottom-1rem text-center">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-if="!isDoneLoading" class="text-center message">
                    {{ label }}
                    <span class="d-block" v-html="subLabel"></span>
                </span>
                <div v-if="isDoneLoading" class="text-center message">
                    <div>
                        <img src="@/assets/blue-success.png" alt="">
                    </div>
                    <span>
                    {{ label }}
                    <span class="d-block" v-html="subLabel"></span>

                </span>
                <el-button type="peiso-primary-pink m-top-1-5rem" class="w-100" @click="hideModal">Okay</el-button>
                </div>
            </div>
        </div>
   </div>
</template>
<script>

export default {
    data() {
        return {
        }
    },
    props: {
        label: {
            default: ''
        },
        subLabel: {
            default : ''
        },
        isLoading: {
            default: false
        },
        isDoneLoading: {
            default: false
        }
    },
    methods: {
        hideModal() {
            this.$emit('hide-message')
        }
    }
}
</script>

<style lang="scss">
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
.message-dialog-container {
	.loading-container {
		position: fixed;
		left: 0px;
		top: 0px;
		height: 100%;
		background: transparent !important;
		z-index: 10;
		border-radius: 10px;

		.loading-label-wrapper {
			padding: 2rem 3rem;
			//box-shadow: 0 1px 3px rgba(0,0,0,.3);
			z-index: 1000;
      background-color: $gray2;
            min-width: 500px;
            text-align: center;

			@include montserrat-font(14px, normal, 500, $white);

			.loading {
				font-size: 50px;
			}

			.message {
				line-height: 1.5;

				img {
					margin-bottom: 1rem;
				}
			}

            .el-button--peiso-primary-pink {
                max-width: 200px;
                margin-left: auto;
                margin-right: auto;
                font-size: 15px;
                color: #fff;
            }
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modal/messageDialog.vue